import { createRoutine, promisifyRoutine } from 'redux-saga-routines';
import { get } from 'lodash/fp';
import { takeLatest, put, call, select } from 'redux-saga/effects';
import api, { API_HOST } from '../helpers/api';
import { SECURITY_TOKEN, POSTCODE_PARAM } from '../helpers/constants';

export const createQuote = createRoutine('quotes/CREATE_QUOTE');
export const getQuote = createRoutine('quotes/GET_QUOTE');

export const createQuotePromiseCreator = promisifyRoutine(createQuote);

function* handleCreateQuote({ payload }: any) {
  try {
    // @ts-expect-error fix type for yield
    const locale = yield select(get('intl.locale'));
    const body = JSON.stringify(payload);
    yield put(createQuote.request());
    // @ts-expect-error fix type for yield
    const quotePackage = yield call(api.post, `${API_HOST}/quotes/?language=${locale}`, false, { body });
    yield put(createQuote.success({ id: quotePackage.id, locale, quotePackage }));
  } catch (error) {
    yield put(createQuote.failure(error));
  } finally {
    yield put(createQuote.fulfill());
  }
}

function* handleGetQuote({ payload: id }: { payload: string; type: string }) {
  try {
    // @ts-expect-error fix type for yield
    const locale = yield select(get('intl.locale'));
    // @ts-expect-error fix type for yield
    const search = yield select(get('router.location.search'));
    const urlParams = new URLSearchParams(search);
    const postcodeParam = urlParams.get(POSTCODE_PARAM);
    if (postcodeParam) {
      sessionStorage.setItem(
        'quoteValues',
        JSON.stringify({
          address: {
            country: 'AU',
            postcode: atob(postcodeParam),
          },
        }),
      );
    }
    const securityToken = urlParams.get(SECURITY_TOKEN);
    const queryString = securityToken ? `?language=${locale}&security_token=${securityToken}` : `?language=${locale}`;
    yield put(getQuote.request());
    // @ts-expect-error fix type for yield
    const quotePackage = yield call(api.get, `${API_HOST}/quotes/${id}/${queryString}`, false);
    yield put(getQuote.success({ id, locale, quotePackage }));
  } catch (error) {
    yield put(getQuote.failure(error));
  } finally {
    yield put(getQuote.fulfill());
  }
}

export function* quotesSaga() {
  yield takeLatest(getQuote.TRIGGER, handleGetQuote);
  yield takeLatest(createQuote.TRIGGER, handleCreateQuote);
}
